import React from "react";
import {
  CheckboxContainer,
  CheckboxLabel,
  HeaderSection,
  MainContainer,
  Partition,
} from "../index.styled";
import { ReactComponent as QualityFilter } from "../../../Assets/Icons/QualityFilter.svg";
import styled from "styled-components";
import { viewSizeCalculator } from "../../../utils";
import CustomInput from "../../Input";

const QualityOfCare = ({ data, reference, handleInputChange }) => {
  const fields = data.fields;

  // Render a single checkbox
  const renderCheckbox = (field, index) => (
    <CheckboxContainer key={index}>
      <input
        style={{
          cursor: "pointer",
          accentColor: "#F96250",
          width: viewSizeCalculator(1.063),
          height: viewSizeCalculator(1.063),
        }}
        type="checkbox"
        id={field.label}
      />
      <CheckboxLabel htmlFor={field.label}>{field.label}</CheckboxLabel>
    </CheckboxContainer>
  );

  // Render a row of checkboxes (2 columns per row)
  const renderRow = (startIndex, endIndex) => (
    <tr key={startIndex}>
      {fields.slice(startIndex, endIndex).map((field, index) => (
        <Td key={startIndex + index}>
          {renderCheckbox(field, startIndex + index)}
        </Td>
      ))}
    </tr>
  );

  // Render all rows dynamically, starting from fields[3]
  const renderTable = () => {
    const rows = [];
    const startIndex = 3; // Start from fields[3]
    for (let i = startIndex; i < fields.length; i += 2) {
      rows.push(renderRow(i, i + 2)); // 2 columns per row
    }
    return rows;
  };
  return (
    <MainContainer ref={reference}>
      <HeaderSection>
        <QualityFilter />
        {data.category}
      </HeaderSection>
      <ContentWrapper>
        <RowContainer>
          <CustomInput
            type={"text"}
            dropdown={fields[0].type}
            placeholder={fields[0].placeholder}
            height={2.2}
            onChange={handleInputChange}
          />
          <CustomInput
            type={"text"}
            dropdown={fields[1].type}
            placeholder={fields[1].placeholder}
            height={2.2}
            onChange={handleInputChange}
          />
        </RowContainer>
        <Partition />
        <Table>
          <tbody>{renderTable()}</tbody>
        </Table>
      </ContentWrapper>
    </MainContainer>
  );
};

export default QualityOfCare;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: ${({ wrap }) => (wrap ? "wrap" : "no-wrap")};
  gap: 20px;

  width: ${({ width }) => width || "50%"};
`;

const Table = styled.table`
  width: 80%;
`;

const Td = styled.td`
  padding-bottom: 1.25rem;
`;
